import {ARGS} from "../bootstrap/args";

import {ENVIRONMENTS, ROUTE_NAMES, WIDGET_TYPES, WINNER_STATUSES} from "../consts";
import {BETTING_CONTAINER} from "../../containers/betting-container/betting-container-consts";

export const APP = {
  ACTION_TYPES: {
    fetchOdds: 'fetchOdds',
    fetchSports: 'fetchSports',
    fetchUsers: 'fetchUsers',
    fetchTheme: 'fetchTheme',
    fetchTerms: 'fetchTerms',
    publishUserData: 'publishUserData',
    fetchPublisher: 'fetchPublisher',
    fetchLocale: 'fetchLocale',
    broadcastUserData: 'broadcastUserData',
    wizardABTesting: 'wizardABTesting',
    subscribeUser: 'subscribeUser',
    pushNotificationsUserSelection: 'pushNotificationsUserSelection',
    pushNotificationsRequestPermissionHandler: 'pushNotificationsRequestPermissionHandler',
    openNotificationsMessage: 'openNotificationsMessage',
    changeUserVisitNotification: 'changeUserVisitNotification',
    widgetView: 'widgetView',
    clearStates: 'clearStates',
    fetchEntitiesRecognizer: 'fetchEntitiesRecognizer',
    poweredByDetector: 'poweredByDetector',
    storeCampaignData: 'StoreCampaignData',
    fetchRaffleBookmaker: 'fetchRaffleBookmaker',
    onPoweredByMissingOrAlteredDisplay: 'onPoweredByMissingOrAlteredDisplay',
    fetchBolaoSettings: 'fetchBolaoSettings',
    gridLayoutABTesting: 'gridLayoutABTesting',
    gridLayoutSelectedEvent: 'gridLayoutSelectedEvent',
    notificationGuideDisplayHandler: 'notificationGuideDisplayHandler',
    minuteMediaPlayerABTesting: 'minuteMediaPlayerABTesting',
    minuteMediaPlayerSelectedEvent: 'minuteMediaPlayerSelectedEvent'
  },
  GOOGLE_ANALYTICS: {
    PAGES: {
      [ROUTE_NAMES.allScores]: 'all-scores',
      [ROUTE_NAMES.myScoresPage]: 'my-scores',
      [ROUTE_NAMES.dashboardPage]: 'all-scores',
      [ROUTE_NAMES.game]: 'game-center',
      [ROUTE_NAMES.match]: 'game-match-page',
      [ROUTE_NAMES.lineups]: 'game-lineups-page',
      [ROUTE_NAMES.stats]: 'game-stats-page',
      [ROUTE_NAMES.h2h]: 'game-h2h-page',
      [ROUTE_NAMES.competitionScores]: 'competition-scores',
      [ROUTE_NAMES.competitorScores]: 'competitor-scores',
      [ROUTE_NAMES.following]: 'following',
      [ROUTE_NAMES.catalog]: 'catalog',
      [ROUTE_NAMES.sliderPage]: 'slider',
      [ROUTE_NAMES.predictions]: 'prediction',
      [ROUTE_NAMES.topGames]: 'top-games',
      [ROUTE_NAMES.bettingOpportunity]: 'betting-opportunity',
      [ROUTE_NAMES.keyPlayers]: 'key-players',
      none: 'externalWidget'
    },
    SOURCES: {
      allScores: 'all-scores',
      myScores: 'my-scores',
      [ROUTE_NAMES.competitionScores]: 'competition-scores',
      [ROUTE_NAMES.competitorScores]: 'competitor-scores',
      entityHeader: 'entity-header',
      scoresList: 'scores-list',
      popularEntities: 'popular-entities',
      catalog: 'catalog',
      search: 'search',
      wizard: 'wizard',
      prediction: 'prediction',
      teaser: 'teaser',
      nextMatch: 'nextMatch',
      currentOdds: 'current-odds',
      slider: 'slider',
      topGames: 'top-games',
      topPerformers: 'top-performers',
      keyPlayers: 'key-players',
      bettingOpportunity: 'betting-opportunity',
      brackets: 'brackets',
      relatedGames: 'relatedGames',
      playerStatsDiv: 'playerStatsDiv',
      outrights: 'outrights'
    },
    APP_TYPES: {
      widget: 'widget',
      website: 'website',
    },
    ENTITY_TYPES: {
      1: "competition",
      2: "competitor",
      3: "sport",
      4: "game",
      5: "athlete"
    },
  },
  ANALYTICS: {
    PROVIDERS: {
      kinesis: 'kinesis',
      googleAnalytics: 'googleAnalytics'
    },
    ENTITY_DISPLAY_TYPES: {
      CompetitionViewModel: 1,
      CompetitorViewModel: 2,
      SportViewModel: 3,
      PartialGameViewModel: 4,
      AthleteViewModel: 5
    },
    SOURCES: {
      mySelections: 'my-selections',
      previousMeetings: 'previous-meetings',
      recentForm: 'recent-form',
      popularEntities: 'popular-entities',
      search: 'search-tool',
      searchBar: 'search-bar',
      scores: 'all-scores',
      liveScores: 'live-scores',
      sortedEntity: 'sorted-entity',
      footer: 'footer',
      header: 'header',
      mobileHeader: 'mobile-header',
      settingsMenu: 'settings-menu',
      gameCenter: 'game-center',
      gameCenterTabs: 'game-center-tabs',
      match: 'match',
      lineups: 'lineups',
      boxScores: 'box-scores',
      playerCard: 'player-card',
      mainHeader: 'main-header',
      mainButton: 'main-button',
      predictions: 'predictions',
      slider: 'slider',
      topGames: 'top-games',
      following: 'following',
      followingStrip: 'following-strip',
      wizard: 'wizard',
      sideMenu: 'side-Menu',
      topPerformers: 'top-performers',
      relatedGames: 'related-games',
      standingsPreview: 'standings-preview',
      playByPlay: 'playByPlay',
      previewPlayByPlay: 'preview-play-by-play',
      matchFacts: 'match-facts',
      keyPlayers: 'key-players',
      entityStats: 'entity-stats',
      bettingOpportunity: 'betting-opportunity',
      featuredGames: 'featured-games',
      bolao: 'bolao',
      allScores: 'all-scores',
      myScores: 'my-scores',
      competitionScores: 'competition-scores',
      competitorScores: 'competitor-scores',
      relatedAthletes: 'relatedAthletes',
      [ROUTE_NAMES.game]: 'match',
      [ROUTE_NAMES.allScoresPage]: 'scores-list',
      [ROUTE_NAMES.dashboardPage]: 'scores-list',
      [ROUTE_NAMES.myScoresPage]: 'scores-list',
      [ROUTE_NAMES.competitionScores]: 'scores-list',
      [ROUTE_NAMES.competitorScores]: 'scores-list',
      [ROUTE_NAMES.competitionStandings]: 'standings',
      [ROUTE_NAMES.competitorStandings]: 'standings',
      [ROUTE_NAMES.competitionBrackets]: 'brackets',
      [ROUTE_NAMES.competitorBrackets]: 'brackets',
      [ROUTE_NAMES.following]: 'following',
      [ROUTE_NAMES.catalog]: 'catalog',
      lastMatches: 'last-matches',
      outrights: 'outrights',
      teamOfTheWeek: 'team-of-the-week',
      trends: 'trends',
      trendsDiv: 'trends-div',
      scoresList: 'scores-list',
      liveStreaming: 'live-streaming',
      transfers: 'transfers',
      trophies: 'trophies',
      nextMatch: 'next-match',
      currentOdds: 'current-odds',
      h2h: 'h2h',
      stats: 'stats',
      athleteNextGame: 'athlete-next-game',
      athletePenalties: 'athlete-penalties',
      livePenalties: 'livePenalties',
      oddsComparison: 'odds-comparison',
      dbaIframe: 'dba-iframe',
      bestOdds: 'bestOdds',
      propositionBets: 'proposition-bets',
      propositionBetsDetails: 'proposition-bets-details',
      bookmakersReview: 'bookmakers-review',
      liveOdds: 'live-odds',
      tagSnippet: 'tag-snippet',
      standings: 'standings',
      oddsBy: 'odds-by',
      medals: 'medals',
      relatedEntities: 'related-entities',
      recentSearch: 'recent-search',
      history: 'history',
      whereToWatch: 'where-to-watch',
      preGameStats: 'pre-game-stats',
      athletePropositionBet: 'athlete-proposition-bet',
      pointByPoint: 'point-by-point',
      activeVideo: 'activeVideo',
      highlights: 'highlights',
      betBoosts: 'bet-boosts',
      competition: 'competition-page',
      competitor: 'competitor-page',
      calculators: 'calculators',
      bettingPost: 'bettingPost',
      brandReview: 'brandReview',
      bettingZone: 'bettingZone',
      oddsByPromotion: 'oddsByPromotion',
      correctScore: 'correct-score',
      outrightsSlider: 'outrights-score',
      oddsMovements: 'odds-movements',
      outrightsCountryFocus: 'outrights-country-focus'
    },
    SCREENS: {
      [ROUTE_NAMES.dashboardPage]: '',
      [ROUTE_NAMES.allScores]: 'all-scores',
      [ROUTE_NAMES.game]: 'match',
      [ROUTE_NAMES.match]: 'match',
      [ROUTE_NAMES.lineups]: 'match',
      [ROUTE_NAMES.stats]: 'match',
      [ROUTE_NAMES.h2h]: 'match',
      [ROUTE_NAMES.trends]: 'match',
      [ROUTE_NAMES.competitionScores]: 'competition',
      [ROUTE_NAMES.competitionStandings]: 'competition',
      [ROUTE_NAMES.competitionBrackets]: 'competition',
      [ROUTE_NAMES.competitorScores]: 'competitor',
      [ROUTE_NAMES.competitorStandings]: 'competitor',
      [ROUTE_NAMES.competitorBrackets]: 'competitor',
      [ROUTE_NAMES.myScoresPage]: 'my-scores',
      [ROUTE_NAMES.following]: 'following',
      [ROUTE_NAMES.catalog]: 'catalog',
      [ROUTE_NAMES.athlete]: 'athlete',
      [ROUTE_NAMES.sliderPage]: 'slider',
      [ROUTE_NAMES.topGames]: 'top-games',
      [ROUTE_NAMES.pages]: 'pages',
      [ROUTE_NAMES.standingsPreview]: 'standings-preview',
      [ROUTE_NAMES.keyPlayers]: 'key-players',
      [ROUTE_NAMES.competitionOdds]: 'odds',
      [ROUTE_NAMES.betting]: 'betting',
    },
    TABS: {},
    WIDGET_CONTEXT_NAME: {
      [BETTING_CONTAINER.ANALYTICS.SOURCE.bookiesCubes]: 'bookiescubes',
      [BETTING_CONTAINER.ANALYTICS.SOURCE.alternateBookies]: 'alternatebookies',
      'bookies-table-comparison': 'comparisontable',
      'betting-opportunity': 'bettingopportunity',
      bookieComparisonTable: 'comparisontable',
      'bestOdds': 'bestodds',
      trends: 'Trends',
      mindeposit: 'mindeposit',
      aceeptpix: 'aceeptpix',
      creditcards: 'creditcards',
      [WIDGET_TYPES.outrights]: 'outrights',
      [WIDGET_TYPES.predictions]: 'predictions',
      hero: 'herocta',
      'sticky-offer': 'stickyoffer',
      'special-offer': 'specialoffer',
      'cta-offers': 'cta-',
    },
    SCREEN_CONTEXT_NAME: {
      'casas-de-apostas': 'bettingsites',
      homePage: 'homepage',
      homepage: 'homepage',
      bettingSites: 'bettingsites',
    },

    USER_SELECTIONS: {
      TYPES: {
        CompetitionViewModel: 1,
        CompetitorViewModel: 2,
        SportViewModel: 3,
        PartialGameViewModel: 4,
        AthleteViewModel: 5,
      },
      STATUSES: {
        select: 'select',
        unselect: 'unselect',
        undo: 'undo'
      }
    },
    PRESENTATION_TYPE: {
      odds: '1X2',
      textualOdds: 'textual-odds',
      logo: 'logo'
    },
    CTA_TYPE: {
      byView: 'by-view',
      byPopular: 'by-popular'
    },
    SELECTION_MAPPER: {
      2: {
        1: 0,
        2: 2,
      },
      3: {
        1: 0,
        2: 1,
        3: 2,
      },
    },
    BUTTON_TYPES_MAPPER: {
      1: {
        1: 1
      },
      2: {
        1: 1,
        2: 3,
      },
      3: {
        1: 1,
        2: 2,
        3: 3,
      },
      bookie: 4,
      betNow: 5,
    },
    DIRECTIONS: {
      LEFT: 0,
      RIGHT: 1,
    },
    IS_BOOKIE: {
      on: 0,
      off: 1
    },
    IS_POWERED_BY: {
      off: 0,
      on: 1,
    },
    WEB_TYPES: {
      site: 'site',
      widget: 'widget'
    },
    WIDGET_TYPES: {
      [WIDGET_TYPES.competitionStandings]: 'standings-competition',
      [WIDGET_TYPES.competitorStandings]: 'standings-competitor',
      [WIDGET_TYPES.slider]: 'slider',
      [WIDGET_TYPES.topGames]: 'top-games list',
      [WIDGET_TYPES.competitionScores]: 'scores-competition',
      [WIDGET_TYPES.competitorScores]: 'scores-competitor',
      [WIDGET_TYPES.game]: 'game',
      [WIDGET_TYPES.predictions]: 'predictions',
      [WIDGET_TYPES.allScores]: 'all-scores',
      // [WIDGET_TYPES.newAllScores]: 'new-all-scores',
      [WIDGET_TYPES.standingsPreview]: 'standings-preview',
      [WIDGET_TYPES.keyPlayers]: 'key-players',
      [WIDGET_TYPES.bettingOpportunity]: 'betting-opportunity',
      [WIDGET_TYPES.website]: null,
      [WIDGET_TYPES.liveStream]: 'liveStream',
      [WIDGET_TYPES.entityStats]: 'entity-stats',
      [WIDGET_TYPES.squad]: 'squad',
      [WIDGET_TYPES.outrights]: 'outrights',
      [WIDGET_TYPES.transfers]: 'transfers',
      trendsDiv: 'trends-div'
    },
    BETS_IMPRESSION_TYPES: {
      main: 'main',
      odds: 'odds',
      cta_button: 'cta_button',
      tooltip: 'tooltip'
    },
    UNDO_CLICK_STATUS: {
      undoSelect: 'undo-select',
      undoUnselect: 'undo-unselect'
    },
    NOTIFICATIONS: {
      TYPES: {
        website: 'website',
        browser: 'browser'
      },
      TRIGGER: {
        wizard: 'wizard',
        selection: 'selection'
      },
      CLICK_TYPE: {
        allow: 'allow',
        deny: 'deny',
        close: 'close'
      },
      WEBSITE: {
        deny: 0,
        allow: 1,
        neverAsked: 2
      }
    },
    CLICK_TYPES: {
      more: "more",
      less: "less"
    }
  },
  CONTEXT: {
    allScores: 'all-scores',
    myScores: 'my-scores',
    competitionScores: 'competition-scores',
    competitorScores: 'competitor-scores'
  },
  USER_DISPLAY: {
    notUserDriven: 0,
    userDriven: 1
  },
  NOTIFICATIONS: {
    ENTITY_TYPES: {
      'none': -1,
      SportViewModel: 0,
      CompetitionViewModel: 1,
      CompetitorViewModel: 2,
      PartialGameViewModel: 3,
      AthleteViewModel: 4
    }
  },
  POWERED_BY_DETECTOR_INTERVAL: {
    start: 3000,
    default: 60000
  },

  DEFAULT_USER_VISIT_FOR_NOTIFICATIONS: 1
}

export const DEV_MODE = (ARGS.NODE_ENV === ENVIRONMENTS.dev);

export const COMPETITION_CATEGORY = {
  default: '',
  top: 'top',
  featured: 'featured'
}

export const COMPETITION_FILTER = {
  default: '',
  stats: 'stats',
  standings: 'standings'
}

export const ENTITY_TYPES = {
  competition: 'league',
  team: 'team',
  game: 'game',
  sport: 'sport',
  athlete: 'athlete'
}

export const SPORT_TYPES = {
  football: 1,
  basketball: 2,
  tennis: 3,
  hockey: 4,
  handball: 5,
  americanFootball: 6,
  baseball: 7,
  volleyball: 8,
  rugby: 9,
  olympics: 10,
  cricket: 11,
  tableTennis: 12,
  eSports: 13,
  onTv: 1000
}

export const SPORT_TYPES_ALIAS_NAMES = {
  [SPORT_TYPES.football]: 'FOOTBALL',
  [SPORT_TYPES.basketball]: 'BASKETBALL',
  [SPORT_TYPES.tennis]: 'TENNIS',
  [SPORT_TYPES.hockey]: 'HOCKEY',
  [SPORT_TYPES.handball]: 'HANDBALL',
  [SPORT_TYPES.americanFootball]: 'A_FOOTBALL',
  [SPORT_TYPES.baseball]: 'BASEBALL',
  [SPORT_TYPES.volleyball]: 'VOLLEYBALL',
  [SPORT_TYPES.rugby]: 'RUGBY',
  [SPORT_TYPES.cricket]: 'CRICKET',
}

export const SOCCER_EVENT_TYPES = {
  goal: 1,
  yellowCard: 2,
  redCard: 3,
  penaltyMiss: 6,
  substitution: 1000,
}

export const WINNING_STATUSES = {
  winning: 1,
  draw: 0,
  loosing: 2
}

export const COMPETITOR_TYPES = {
  team: 1,
  nationalTeam: 2,
  athlete: 4,
  double: 8,
}

export const GAME_STATUSES = {
  ended: 4,
  started: 3,
  scheduled: 2,
  anticipated: 1,
}

export const STATUS_ID = {
  POSTPONED: {
    [SPORT_TYPES.football]: 5,
    [SPORT_TYPES.basketball]: 15,
    [SPORT_TYPES.tennis]: 26,
    [SPORT_TYPES.hockey]: 39,
    [SPORT_TYPES.handball]: 53,
    [SPORT_TYPES.americanFootball]: 63,
    [SPORT_TYPES.baseball]: 74,
    [SPORT_TYPES.volleyball]: 91,
    [SPORT_TYPES.rugby]: 101,
    [SPORT_TYPES.cricket]: 142
  },

  CANCELLED: {
    [SPORT_TYPES.football]: 119,
    [SPORT_TYPES.basketball]: 120,
    [SPORT_TYPES.tennis]: 121,
    [SPORT_TYPES.hockey]: 122,
    [SPORT_TYPES.handball]: 123,
    [SPORT_TYPES.americanFootball]: 124,
    [SPORT_TYPES.baseball]: 125,
    [SPORT_TYPES.volleyball]: 126,
    [SPORT_TYPES.rugby]: 127,
    [SPORT_TYPES.cricket]: 144
  }
}



export const SUSPENSION_TYPES = {
  redCard: 3,
  yellowCards: 2
}

export const GAME_STAGES_ID = {
  'default': -1,
  end90Minutes: 9,
  extraTime: 10,
  halfTime: 7,
  penalties: 11
}

export const ROUTE_VISIBILITY_MODES = {
  all: 'all',
  smallViewOnly: 'smallViewOnly',
  largeViewOnly: 'largeViewOnly',
}

export const GAME_TIME_AND_STATUS_DISPLAY_TYPE = {
  none: 0,
  statusText: 1,
  gameTime: 2,
  gameTimeAndStatusText: 3,
}

export const STANDINGS_TABS = {
  all: "all",
  home: "home",
  away: "away"
}

export const TREND = {
  down: 1,
  even: 2,
  up: 3,
}

export const EXTRA_LINKS_CONTEXTS = {
  tvBroadcasts: 'TVBroadcasts',
  liveOdds: 'LiveOdds',
  gameCenterPredictions: 'GameCenterPredictions',
  predictions: 'Predictions'
}

export const DEFAULT_CULTURE_NAME = 'en';
export const APP_TYPE = 5;

export const HIDDEN_COUNTRIES = [304];

export const PRECISE_GAME_TIME = {
  SECOND: 1000,
  // gap between the local clock and a newly received server time that is treated as a real
  // correction (period change, clock reset) rather than network jitter
  SYNC_TOLERANCE_SECONDS: 10,
  CLOCK_DIRECTION: {
    forward: 1,
    backward: 2
  }
}

export const PUSH_NOTIFICATIONS_PERMISSIONS = {
  denied: 'denied',
  granted: 'granted',
  default: 'default',
}

export const IMAGE_DEFAULT_FORMATS = {
  AUTO: 'auto',
  PNG: 'png',
  SVG: 'svg',
  GIF: 'gif',
  WEBP: 'webp',
  JPG: 'jpg'
}

export const MAX_RESULTS_FOR_RECENT_SEARCHES = 8;

export const HREF_SPORT_TYPES = {
  football: 1,
  basketball: 2,
  hockey: 4,
  americanFootball: 6,
  baseball: 7,
  rugby: 9,
  tableTennis: 12,
  eSports: 13,
}
export const BET_TYPE = {
  trend: "trend",
  insight: "insight",
  none: "none"
}

export const BRIGHTNESS_BG_THRESHOLD = {
  default: 238,
  bettingOpportunity: 170,
}

export const CIE2000_THRESHOLD = {
  contrast: 1.5,
  color: 23,
}

export const OUTCOME = {
  lose: 0,
  win: 1,
  draw: 2,
  drawWin: 3,
  drawLoss: 4,
  lossWin: 5,
  winLoss: 6
}

export const THEME = {
  DARK: "dark",
  LIGHT: "light",
}

export const DEFAULT_TERMS_CATEGORY_NAME = 'WEB';

export const TAG_TITLE = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  div: "div",
  span: "span",
}

export const ATHLETE = {
  BLOCKED_SPORT_TYPES_ATHLETES: [SPORT_TYPES.tennis, SPORT_TYPES.handball, SPORT_TYPES.baseball, SPORT_TYPES.volleyball, SPORT_TYPES.rugby, SPORT_TYPES.cricket]
}

export const OUTRIGHTS = {
  VALUE_TYPE: {
    none: 0,
    odds: 1,
    prediction: 2
  },
  ENTITY_TYPES: {
    competition: 2,
    competitor: 4,
    athlete: 6,
  },
  STATUS: {
    preSeason: 0,
    liveSeason: 1,
    postSeason: 2
  }
}

export const INSIGHT_OUTCOME = {
  win: 1,
  lose: 2,
  void: 3,
}

export const SOCCER_GOAL_SHOT_MAP_SCALE = {
  big: 1,
  small: 2,
}

export const SOCCER_GOAL_OUTCOME = {
  goal: 0,
  missed: 1,
}

export const DBA = {
  PAGE: {
    allScores: 'AllScore',
    myScore: 'MyScore',
    live: 'Live',
    match: 'Match',
    competition: 'Competition',
    competitor: 'Competitor',
    athlete: 'Athlete'
  },
  DEVICE_CATEGORY: {
    mobile: 'Mobile',
    desktop: 'Desktop'
  }

}

export const LINEUPS_CONSTS = {
  boxScoresSportTypes: [
    SPORT_TYPES.basketball,
    SPORT_TYPES.hockey,
    SPORT_TYPES.americanFootball,
    SPORT_TYPES.cricket,
    SPORT_TYPES.volleyball,
  ]
}

export const STORE_DOMAIN = 'www.365scores.info';

export const NAVIGATION_TABS_CONTEXT = {
  matchesTab: 'matches-tab',
  newMatchesTab: 'new-matches-tab',
  competition: 'competition',
  competitor: 'competitor',
}

export const PREMIUM_STATS = {
  ENTITY: [42, 43, 44, 45, 46, 49, 50],
  SPORT: [76, 77, 78, 79, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126],
  ATHLETE: [44, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 229, 230, 234, 239]
}

export const SCORE_IN_90_MAPPER = {
  0: WINNER_STATUSES.lose,
  1: WINNER_STATUSES.win,
  2: WINNER_STATUSES.draw,
  3: WINNER_STATUSES.draw,
  4: WINNER_STATUSES.draw,
  5: WINNER_STATUSES.lose,
  6: WINNER_STATUSES.win
}

export const TENNIS_SCOREBOARD = {
  ADVANTAGE_SCORE: {
    value: 'AD',
    score: 50
  },
  CURRENT_GAME_SCORE_ID: 34
};

export const OLYMPICS_COMPETITION_IDS = [7710];

export const COUNTRYID_TO_CURRENCY_MAP = {
  185: '؋',    // Afghanistan - AFN
  76: 'L',     // Albania - ALL
  139: 'د.ج',  // Algeria - DZD
  103: '€',    // Andorra - EUR
  136: 'Kz',   // Angola - AOA
  10: '$',     // Argentina - ARS
  49: '֏',     // Armenia - AMD
  36: 'A$',    // Australia - AUD
  20: '€',     // Austria - EUR
  77: '₼',     // Azerbaijan - AZN
  186: 'B$',   // Bahamas - BSD
  116: '.د.ب', // Bahrain - BHD
  219: '৳',    // Bangladesh - BDT
  196: 'Bds$', // Barbados - BBD
  104: 'Br',   // Belarus - BYN
  16: '€',     // Belgium - EUR
  195: 'BZ$',  // Belize - BZD
  194: '$',    // Bermuda - BMD
  113: 'Bs.',  // Bolivia - BOB
  57: 'KM',    // Bosnia & Herzegovina - BAM
  63: 'P',     // Botswana - BWP
  21: 'R$',    // Brazil - BRL
  276: 'B$',   // Brunei - BND
  40: 'лв',    // Bulgaria - BGN
  192: 'FBu',  // Burundi - BIF
  73: 'FCFA',  // Cameroon - XAF
  66: 'C$',    // Canada - CAD
  28: '$',     // Chile - CLP
  35: '¥',     // China - CNY
  179: 'NT$',  // Chinese Taipei - TWD
  109: '$',    // Colombia - COP
  153: '₡',    // Costa Rica - CRC
  38: '€',     // Croatia - EUR
  175: '₱',    // Cuba - CUP
  232: 'NAƒ',  // Curaçao - ANG
  39: '€',     // Cyprus - EUR
  22: 'Kč',    // Czechia - CZK
  23: 'kr',    // Denmark - DKK
  183: 'RD$',  // Dominican Republic - DOP
  51: '$',     // Ecuador - USD
  131: 'E£',   // Egypt - EGP
  147: '$',    // El Salvador - USD
  1: '£',      // England - GBP
  102: '€',    // Estonia - EUR
  70: 'Br',    // Ethiopia - ETB
  25: '€',     // Finland - EUR
  5: '€',      // France - EUR
  143: 'FCFA', // Gabon - XAF
  78: '₾',     // Georgia - GEL
  4: '€',      // Germany - EUR
  65: 'GH₵',   // Ghana - GHS
  209: '£',    // Gibraltar - GIP
  13: '€',     // Greece - EUR
  140: 'Q',    // Guatemala - GTQ
  199: 'G$',   // Guyana - GYD
  152: 'G',    // Haiti - HTG
  169: 'L',    // Honduras - HNL
  79: 'HK$',   // Hong Kong - HKD
  30: 'Ft',    // Hungary - HUF
  32: 'kr',    // Iceland - ISK
  80: '₹',     // India - INR
  75: 'Rp',    // Indonesia - IDR
  81: '﷼',     // Iran - IRR
  114: 'ع.د',  // Iraq - IQD
  9: '€',      // Ireland - EUR
  6: '₪',      // Israel - ILS
  3: '€',      // Italy - EUR
  74: 'CFA',   // Ivory Coast - XOF
  151: 'J$',   // Jamaica - JMD
  34: '¥',     // Japan - JPY
  119: 'JD',   // Jordan - JOD
  105: '₸',    // Kazakhstan - KZT
  144: 'KSh',  // Kenya - KES
  205: '€',    // Kosovo - EUR
  126: 'د.ك',  // Kuwait - KWD
  202: 'сом',  // Kyrgyzstan - KGS
  41: '€',     // Latvia - EUR
  123: 'L£',   // Lebanon - LBP
  138: 'L$',   // Liberia - LRD
  161: 'ل.د',  // Libya - LYD
  101: 'CHF',  // Liechtenstein - CHF
  42: '€',     // Lithuania - EUR
  92: '€',     // Luxembourg - EUR
  82: 'RM',    // Malaysia - MYR
  128: 'CFA',  // Mali - XOF
  93: '€',     // Malta - EUR
  190: '₨',    // Mauritius - MUR
  31: '$',     // Mexico - MXN
  91: 'L',     // Moldova - MDL
  181: '₮',    // Mongolia - MNT
  84: '€',     // Montenegro - EUR
  127: 'د.م.', // Morocco - MAD
  55: 'K',     // Myanmar - MMK
  64: 'N$',    // Namibia - NAD
  7: '€',      // Netherlands - EUR
  159: 'NZ$',  // New Zealand - NZD
  182: 'C$',   // Nicaragua - NIO
  201: 'CFA',  // Niger - XOF
  83: '₦',     // Nigeria - NGN
  180: '₩',    // North Korea - KPW
  56: 'ден',   // North Macedonia - MKD
  99: '£',     // Northern Ireland - GBP
  27: 'kr',    // Norway - NOK
  117: '﷼',    // Oman - OMR
  172: '₨',    // Pakistan - PKR
  226: '₪',    // Palestine - ILS
  146: 'B/.',  // Panama - PAB
  108: '₲',    // Paraguay - PYG
  112: 'S/.',  // Peru - PEN
  200: '₱',    // The Philippines - PHP
  37: 'zł',    // Poland - PLN
  11: '€',     // Portugal - EUR
  178: '$',    // Puerto Rico - USD
  115: '﷼',    // Qatar - QAR
  29: 'lei',   // Romania - RON
  14: '₽',     // Russia - RUB
  122: '﷼',    // Saudi Arabia - SAR
  8: '£',      // Scotland - GBP
  133: 'CFA',  // Senegal - XOF
  85: 'din.',  // Serbia - RSD
  50: 'S$',    // Singapore - SGD
  33: '€',     // Slovakia - EUR
  46: '€',     // Slovenia - EUR
  134: 'R',    // South Africa - ZAR
  86: '₩',     // South Korea - KRW
  2: '€',      // Spain - EUR
  130: 'ج.س.', // Sudan - SDG
  212: 'SRD',  // Suriname - SRD
  24: 'kr',    // Sweden - SEK
  15: 'CHF',   // Switzerland - CHF
  125: '£S',   // Syria - SYP
  163: 'NT$',  // Taiwan - TWD
  184: 'SM',   // Tajikistan - TJS
  141: 'TSh',  // Tanzania - TZS
  118: '฿',    // Thailand - THB
  71: 'CFA',   // Togo - XOF
  148: 'TT$',  // Trinidad and Tobago - TTD
  135: 'د.ت',  // Tunisia - TND
  12: '₺',     // Turkiye - TRY
  120: 'T',    // Turkmenistan - TMT
  124: 'د.إ',  // UAE - AED
  137: 'USh',  // Uganda - UGX
  26: '₴',     // Ukraine - UAH
  166: '£',    // United Kingdom - GBP
  111: '$U',   // Uruguay - UYU
  18: '$',     // USA - USD
  121: 'сўм',  // Uzbekistan - UZS
  110: 'Bs.F', // Venezuela - VES
  155: '₫',    // Vietnam - VND
  100: '£',    // Wales - GBP
  170: '﷼',    // Yemen - YER
  132: 'ZK',   // Zambia - ZMW
  60: 'Z$',    // Zimbabwe - ZWL
};

export const DEVICE_TYPE = {
  android: 'android',
  ios: 'ios',
  pc: 'pc',
  mac: 'mac'
}

export const LINEUPS_STATUS = {
  none: 0,
  injuryReport: 1,
  probableLineups: 2,
  confirmedLineups: 3
}

export const CUSTOM_HTML_ENTITY_TYPES = {
  game: 'game',
  sportType: 'sport_type',
  competition: 'competition',
  competitor: 'competitor'
}